import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { AuditService } from 'src/app/services/api/audit.service';
import { TranslocoModule } from '@jsverse/transloco';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-audit-details-dialog',
  templateUrl: './audit-details-dialog.component.html',
  styleUrls: ['./audit-details-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatTabsModule,
    TranslocoModule
  ]
})
export class AuditDetailsDialogComponent implements OnInit {
  @Input() audit: any;  
  @Input() auditData: any;  
  @Input() JsonData: any;
  @Input() copyJsonData: boolean; 
  tenantData: any;
  copyReq: boolean;
  copyRes: boolean;
  formattedReqBody: string[] = [];
  formattedResBody: string[] = [];
  constructor(
    private auditService: AuditService,
    private sidenavService: SidenavService,
    private clipboardApi: ClipboardService
  ) {}

  ngOnInit(): void {
      this.tenantData = this.auditData;
      const reqJsonString = JSON.stringify(this.tenantData.requestBody, null, 2);
      const resJsonString = JSON.stringify(this.tenantData.responseBody, null, 2);
      this.formattedReqBody = reqJsonString?.split('\n');
      this.formattedResBody = resJsonString?.split('\n');
      this.copyReq = false;
      this.copyRes = false;
  }

  copyReqText(): void {
    let copyJson = this.formattedReqBody.join('\n');
    this.copyReq = true;
    this.clipboardApi.copyFromContent(copyJson);
    setTimeout(() => {
      this.copyReq = false;
    }, 5000);
  }

  copyResText(): void {
    let copyJson = this.formattedResBody.join('\n');
    this.copyRes = true;
    this.clipboardApi.copyFromContent(copyJson);
    setTimeout(() => {
      this.copyRes = false;
    }, 5000);
  }

  closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
  }

  getHttpMethodClass(method: string): string {
    switch (method?.toUpperCase()) {
      case 'GET': return 'http-get';
      case 'POST': return 'http-post';
      case 'PUT': return 'http-put';
      case 'PATCH': return 'http-patch';
      case 'DELETE': return 'http-delete';
      case 'HEAD': return 'http-head';
      case 'OPTIONS': return 'http-options';
      default: return '';
    }
  }

  getResponseText(code: number | string): { class: string, text: string } {
    switch (String(code)) {
      case '100': return { class: 'http-continue', text: 'Continue' };
      case '200': return { class: 'http-created', text: 'OK' };
      case '201': return { class: 'http-created', text: 'Created' };
      case '202': return { class: 'http-created', text: 'Accepted' };
      case '204': return { class: 'http-created', text: 'No Content' };
      case '301': return { class: 'http-moved', text: 'Moved Permanently' };
      case '302': return { class: 'http-moved', text: 'Found' };
      case '304': return { class: 'http-moved', text: 'Not Modified' };
      case '400': return { class: 'http-bad', text: 'Bad Request' };
      case '401': return { class: 'http-bad', text: 'Unauthorized' };
      case '403': return { class: 'http-bad', text: 'Forbidden' };
      case '404': return { class: 'http-bad', text: 'Not Found' };
      case '500': return { class: 'http-error', text: 'Internal Server Error' };
      case '502': return { class: 'http-error', text: 'Bad Gateway' };
      default: return { class: 'http-default', text: '' };
    }
  }
}